import { render, staticRenderFns } from "./Revised.vue?vue&type=template&id=3922cda2&"
import script from "./Revised.vue?vue&type=script&lang=js&"
export * from "./Revised.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports